<template>
  <div class="popover-customer">
    <div class="phone">0755-26919327</div>
    <div class="week">{{ working_time_list[0] }}</div>
    <div class="time">{{ working_time_list[1] }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
    working_time_list() {
      if (!this.customer_service || !this.customer_service.working_time) return [];
      const working_time_list = this.customer_service.working_time ? this.customer_service.working_time.split(' ') : [];
      const work = working_time_list[0];
      working_time_list.splice(0, 1);
      const time = working_time_list.length ? working_time_list.join(' ') : '';
      return [work, time];
    },
  },
};
</script>

<style lang="less" scoped>
.popover-customer {
  padding: 16px 18px;
  font-size: 12px;
  color: #5F666E;
  line-height: 17px;
  >div {
    white-space: nowrap;
  }
  .phone {
    font-size: 24px;
    color: #599FFF;
    line-height: 33px;
    font-weight: 600;
  }
  .week {
    margin: 2px 0 4px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/popover/popover-customer.vue